export const environment = {
  production: true,
  rootUrl: '#API_BASE_PATH'
};
/*
NOTE
Must be 'http://localhost:4200' for Deployment with Octopus
*/
